export const FAQS = [
  {
    title: "Is this Kubernetes distribution CNCF-certified?",
    content: "Yes. It’s 100% upstream Kubernetes and fully CNCF-compliant.",
  },
  {
    title: "Can I run both public and private workloads?",
    content:
      "Yes. You can isolate workloads with namespaces and use RBAC to control access.",
  },
  {
    title: "Does it support horizontal pod autoscaling?",
    content: "Absolutely. Workloads scale based on CPU/memory or custom metrics.",
  },
  {
    title: "How is the cluster secured?",
    content:
      "Each cluster comes with RBAC, TLS, isolated namespaces, and network policies.",
  },
  {
    title: "Can I integrate GitOps tools like ArgoCD or Flux?",
    content: "Yes. Taikun supports GitOps workflows out of the box.",
  },
  {
    title: "Is monitoring included or do I need Prometheus separately?",
    content: "Monitoring is included—no extra setup required.",
  },
  {
    title: "How does auto-scaling of nodes work?",
    content:
      "Node pools scale dynamically based on pod resource needs and scheduler pressure.",
  },
  {
    title: "Is there support for multi-cloud or hybrid clusters?",
    content:
      "Yes. You can manage clusters across different cloud providers and on-prem with a unified control plane.",
  },
  {
    title: "Can I use Helm for app deployment?",
    content: "Yes. Helm charts are fully supported.",
  },
  {
    title: "What’s the SLA or uptime guarantee?",
    content: "OneMind delivers 99.99% uptime on managed control plane infrastructure.",
  },
];
